import Alpine from 'alpinejs'
import header from "./components/header";
import initCardStack from "./components/card-stack";
import initSwiper from "./components/swiper";
import initLogoLoop from "./components/logo-loop";
import initTestimonialCarousel from "./components/testimonial-carousel";
import initScenarioTabs from "./components/scenario-tabs";
import initVideo from "./components/video";
import.meta.glob([ '@images/**' ]);

Alpine.data('header', header)

window.Alpine = Alpine;
Alpine.start();

(async () => {
    initCardStack();
    initScenarioTabs();

    await initVideo();
    await initSwiper();
    await initLogoLoop();
    await initTestimonialCarousel();
})();